module.exports = __webpack_public_path__ + "img/syllabus-boy.ecac360e.png";